import { PAY_PAL_CLIENT_ID } from 'modules/payment/services/paypal/constants'

function initPayPalService () {
  return new Promise((resolve, reject) => {
    if (window.paypal) {
      resolve()
      return
    }
    import(/* webpackChunkName: "scriptjs" */ 'scriptjs')
      .then(script => {
        if (!window.navigator.onLine) {
          reject(new Error('no internet connection: could not initialize payment system PayPal'))
          return
        }
        script.default(`https://www.paypal.com/sdk/js?client-id=${PAY_PAL_CLIENT_ID}`, () => {
          resolve()
        })
      })
  })
}

export {
  initPayPalService
}
